import React, {useRef, useEffect} from "react";
import { useTour } from "@reactour/tour";
import { useLocation } from "react-router-dom";
import { update } from "idb-keyval";
// -------------------------------
// Functional bridge for the tour
// -------------------------------
export function TourBridge({ children, showTour, incognitoBrowser, updateState, accordionRef }) {
  const { setIsOpen, setCurrentStep } = useTour();
  const location = useLocation();

  React.useEffect(() => {
    // Normalize the path so /training/select → training_select
    const pathKey = location.pathname.replace(/[^\w]/g, "_") || "root";
    const key = `hasSeenTrainingTour_${pathKey}`;

    const hasSeenTour = localStorage.getItem(key);
      console.log("TourBridge checking tour for path:", location.pathname, " showTour:", showTour, " incognitoBrowser:", incognitoBrowser, " hasSeenTour:", hasSeenTour);
    if (!hasSeenTour) {
      updateState({showTour: !incognitoBrowser});
      localStorage.setItem(key, "true");
    }else if (typeof showTour === "boolean") {
      setIsOpen(showTour);
      if(showTour && accordionRef?.current && location.pathname === '/main-accordion'){
        const openedRaw = accordionRef.current.state?.openedTab;
        const openedNum = Number(openedRaw);
        if(openedNum <= 4)
          setCurrentStep(openedNum);
        else if(openedNum < 99)
          setCurrentStep(5);
        else if(openedNum === 99)
          setCurrentStep(6);        
        else if(openedNum === 100){
          setCurrentStep(7);
        }
      }
    }
  }, [incognitoBrowser, showTour, setIsOpen, location, updateState]);

  return (
    <div>{children}</div>
  );
}

export function SkipHiddenTourSteps () {
  const { currentStep, steps, setCurrentStep, setIsOpen } = useTour();
  const prevStepRef = useRef(currentStep); // keep track of previous step

  useEffect(() => {
    const step = steps[currentStep];
    const el = document.querySelector(step?.selector);

    const isElementHidden = (element) => {
      if (!element) return true;
      const styles = window.getComputedStyle(element);
      return (
        element.offsetParent === null ||
        styles.visibility === 'hidden' ||
        styles.opacity === '0' ||
        styles.display === 'none'
      );
    };

    // Determine direction of navigation
    const previousStep = prevStepRef.current;
    const movingForward = currentStep > previousStep || (previousStep === 0 && currentStep === steps.length - 1);

    // If the current step element is missing or hidden, skip in the right direction
    if (!el || isElementHidden(el)) {
      if (movingForward) {
        // Skip forward
        if (currentStep + 1 < steps.length) {
          setCurrentStep(currentStep + 1);
        } else {
          setCurrentStep(0);
        }
      } else {
        // Skip backward
        if (currentStep - 1 >= 0) {
          setCurrentStep(currentStep - 1);
        }else{
          setCurrentStep(steps.length - 1);
        }
      }
    }

    // Store this step as previous for next effect run
    prevStepRef.current = currentStep;
  }, [currentStep, steps, setCurrentStep, setIsOpen]);

  return null; // invisible helper component
}
